import { render, staticRenderFns } from "./shop-cart-sticky.vue?vue&type=template&id=067a2c9f&scoped=true"
import script from "./shop-cart-sticky.vue?vue&type=script&lang=js"
export * from "./shop-cart-sticky.vue?vue&type=script&lang=js"
import style0 from "./shop-cart-sticky.vue?vue&type=style&index=0&id=067a2c9f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a2c9f",
  null
  
)

export default component.exports